import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    healing: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    accessibility: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/>
      </svg>
    ),
    fitness_center: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"/>
      </svg>
    ),
    self_improvement: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    ),
    sports: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M9 5v2c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1zm0 12v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zm5-7v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1z"/>
      </svg>
    ),
    local_hospital: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 8h2v8H4zm0-2h2V4H4zm12 0h2V4h-2zm0 2h2v8h-2zM8 20h8v-2H8zm0-16h8V2H8z"/>
      </svg>
    ),
    back_hand: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M13 24c-3.26 0-6.19-1.99-7.4-5.02l-3.03-7.61C2.26 10.58 3 9.79 3.81 9.79c.51 0 .98.21 1.33.55L8 13.2V3.5C8 2.67 8.67 2 9.5 2s1.5.67 1.5 1.5v8.15l.85-.77c.39-.39.9-.59 1.43-.59 1.13 0 2.05.92 2.05 2.05 0 .57-.23 1.08-.6 1.45l-3.5 3.5c-.39.39-.9.59-1.43.59s-1.04-.2-1.43-.59L6.5 14.96 8.73 20.3c.73 1.84 2.54 3.04 4.58 3.04 2.67 0 4.85-2.18 4.85-4.85V11c0-.55.45-1 1-1s1 .45 1 1v7.49C20.16 21.28 17.04 24 13 24z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const ChiropractorLanding = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'chiropractic practice'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Back Pain Emergency",
      time: "Monday, 8:45 AM",
      customer: "I threw out my back and can barely move. I need to see a chiropractor immediately",
      response: "I understand you're in severe pain. I can get you in for an emergency appointment at 11:30 AM today. Dr. Smith specializes in acute back injuries.",
      outcome: "$185 emergency visit",
      color: "blue"
    },
    {
      type: "Spinal Adjustment",
      time: "Wednesday, 2:30 PM",
      customer: "I need a spinal adjustment, my neck has been stiff for weeks",
      response: "I can schedule your spinal adjustment for Friday at 1 PM. This will be a comprehensive exam and adjustment to address your neck stiffness.",
      outcome: "$95 adjustment",
      color: "blue"
    },
    {
      type: "Wellness Check",
      time: "Thursday, 10:15 AM",
      customer: "I'd like to schedule a wellness visit to maintain my spinal health",
      response: "Great! I can schedule your wellness visit for next Tuesday at 3 PM. This will include a full assessment and preventive care plan.",
      outcome: "$125 wellness visit",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Every patient call is handled with care and urgency. Our emergency appointments are filled immediately, and our practice has grown 80%.",
      author: "Dr. Michael S.",
      business: "Spine & Wellness Center",
      result: "80% practice growth"
    },
    {
      quote: "The AI understands pain levels and schedules accordingly. Patients with severe pain get priority scheduling automatically.",
      author: "Dr. Jennifer L.",
      business: "Back to Health Chiropractic",
      result: "95% patient satisfaction"
    },
    {
      quote: "From emergency visits to wellness care, every call is handled professionally. Our patients feel heard and cared for.",
      author: "Dr. Robert K.",
      business: "Active Life Chiropractic",
      result: "Booked 7 weeks ahead"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'chiropractic practice' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Receptioneer.ai - AI Receptionist for Chiropractors",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web Browser",
    "description": "AI-powered receptionist service specifically designed for chiropractic practices. Handles calls, books appointments, and captures leads 24/7.",
    "offers": {
      "@type": "Offer",
      "price": "399",
      "priceCurrency": "USD",
      "priceValidUntil": "2025-12-31",
      "availability": "https://schema.org/InStock"
    },
    "provider": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    }
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist for Chiropractors | Never Miss Another Chiropractic Appointment"
        description="Get more chiropractic appointments with an AI receptionist that handles calls 24/7. Books adjustments, emergencies, and wellness visits automatically. Starting at $399/month."
        keywords="chiropractor ai receptionist, chiropractic appointment booking, spine care virtual receptionist, chiropractic practice phone service, back pain scheduling system, spinal adjustment receptionist"
        canonical="https://receptioneer.ai/chiropractor"
        ogTitle="AI Receptionist for Chiropractors - Never Miss Another Chiropractic Appointment"
        ogDescription="AI receptionist that handles chiropractic calls 24/7. Books adjustments, emergencies, and wellness visits automatically. Perfect for spine care practices."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-blue-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🦴 For Chiropractors
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another
                <br />
                <span className="text-blue-200">Chiropractic Visit</span>
              </h1>
              
              <p className="text-xl text-blue-100 mb-8 leading-relaxed">
                From emergency back pain to wellness care, your AI receptionist handles every call with urgency and care. 
                <strong className="text-white">Books appointments, manages schedules, and captures patients 24/7.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get My Chiropractic AI →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test It Live
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-blue-200 text-sm">Patient care</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">$399</div>
                  <div className="text-blue-200 text-sm">Per month</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24hrs</div>
                  <div className="text-blue-200 text-sm">Setup time</div>
                </div>
              </div>
            </div>

            <div className="bg-blue-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className={`w-4 h-4 rounded-full animate-pulse ${
                    callExamples[currentCallType].color === 'red' ? 'bg-red-500' :
                    callExamples[currentCallType].color === 'green' ? 'bg-green-500' : 'bg-blue-500'
                  }`}></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Patient:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className={`rounded-lg p-3 ${
                    callExamples[currentCallType].color === 'red' ? 'bg-red-50' :
                    callExamples[currentCallType].color === 'green' ? 'bg-green-50' : 'bg-blue-50'
                  }`}>
                    <div className={`text-xs font-semibold mb-1 ${
                      callExamples[currentCallType].color === 'red' ? 'text-red-600' :
                      callExamples[currentCallType].color === 'green' ? 'text-green-600' : 'text-blue-600'
                    }`}>AI Response:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className={`text-lg font-black ${
                    callExamples[currentCallType].color === 'red' ? 'text-red-600' :
                    callExamples[currentCallType].color === 'green' ? 'text-green-600' : 'text-blue-600'
                  }`}>{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Appointment scheduled</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-blue-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Every Type of <span className="text-blue-900">Chiropractic Service</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-red-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="local_hospital" className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Emergency Care</h3>
                <ul className="space-y-2 text-gray-700 mb-6">
                  <li>• Acute back pain</li>
                  <li>• Neck injuries</li>
                  <li>• Sciatica treatment</li>
                  <li>• Whiplash recovery</li>
                  <li>• Sports injuries</li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="back_hand" className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Spinal Adjustments</h3>
                <ul className="space-y-2 text-gray-700 mb-6">
                  <li>• Spinal manipulation</li>
                  <li>• Joint mobilization</li>
                  <li>• Cervical adjustments</li>
                  <li>• Lumbar treatments</li>
                  <li>• Postural correction</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="self_improvement" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Wellness Care</h3>
                <ul className="space-y-2 text-gray-700 mb-6">
                  <li>• Preventive care</li>
                  <li>• Maintenance visits</li>
                  <li>• Ergonomic assessments</li>
                  <li>• Exercise therapy</li>
                  <li>• Lifestyle counseling</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Chiropractic Practices Are Growing With <span className="text-blue-900">AI Receptionists</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="healing" className="w-8 h-8 text-blue-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-blue-50 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-blue-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              One Visit Pays for Everything
            </h2>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-blue-100 mb-6">per month • unlimited calls • all chiropractic services</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get My Chiropractic AI →
              </button>
            </div>
            
            <p className="text-blue-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Chiropractic AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your chiropractic AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Dr. Michael Smith"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="dr.smith@spinewellness.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Chiropractic AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/chiropractor" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ChiropractorLanding;